import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
export const initialValue = {
    selectedSamsUser: {
        value: {
            cardType: '',
            'cipher.firstName': '',
            'cipher.lastName': '',
            'cipher.dateOfBirth': '',
            partnerId: '',
            memberId: ''
        },
        errorMessage: '',
        touched: false
    },
    isAuthorizedUserSubmitted: false,
    eligibleMembers: [],
    updateDateOfBirth: () => { },
    updateEligibleMembers: () => { },
    updateSelectedSamsUser: () => { },
    updateIsAuthorizedUserSubmitted: () => { }
};
export const ManageCardholderModalContext = createContext(initialValue);
export const useManageCardHolderModalContext = () => {
    return useContext(ManageCardholderModalContext);
};
ManageCardholderModalContext.displayName = 'ManageCardHolderModalContext';
var ManageCardholderModalContextTypes;
(function (ManageCardholderModalContextTypes) {
    ManageCardholderModalContextTypes["SET_DATE_OF_BIRTH"] = "SET_DATE_OF_BIRTH";
    ManageCardholderModalContextTypes["SET_ELIGIBLE_MEMBERS"] = "SET_ELIGIBLE_MEMBERS";
    ManageCardholderModalContextTypes["SET_SELECTED_SAMS_USER"] = "SET_SELECTED_SAMS_USER";
    ManageCardholderModalContextTypes["SET_IS_USER_SUBMITTED"] = "SET_IS_USER_SUBMITTED";
})(ManageCardholderModalContextTypes || (ManageCardholderModalContextTypes = {}));
const reducer = (state, action) => {
    switch (action.type) {
        case ManageCardholderModalContextTypes.SET_DATE_OF_BIRTH:
            return {
                ...state,
                selectedSamsUser: {
                    ...state.selectedSamsUser,
                    value: {
                        ...state.selectedSamsUser.value,
                        'cipher.dateOfBirth': action.newDateOfBirth
                    }
                }
            };
        case ManageCardholderModalContextTypes.SET_ELIGIBLE_MEMBERS:
            return {
                ...state,
                eligibleMembers: action.newEligibleMembers || []
            };
        case ManageCardholderModalContextTypes.SET_SELECTED_SAMS_USER:
            return {
                ...state,
                selectedSamsUser: action.newSelectedSamsUser || initialValue.selectedSamsUser
            };
        case ManageCardholderModalContextTypes.SET_IS_USER_SUBMITTED:
            return {
                ...state,
                isAuthorizedUserSubmitted: action.newIsAuthorizedUserSubmitted
            };
        default:
            return state;
    }
};
const ManageCardholderModalContextProvider = ({ children, customState }) => {
    const [state, dispatch] = useReducer(reducer, {
        ...initialValue,
        ...customState
    });
    const updateDateOfBirth = useCallback((newDateOfBirth) => {
        dispatch({
            type: ManageCardholderModalContextTypes.SET_DATE_OF_BIRTH,
            newDateOfBirth
        });
    }, []);
    const updateEligibleMembers = useCallback((newEligibleMembers) => {
        dispatch({
            type: ManageCardholderModalContextTypes.SET_ELIGIBLE_MEMBERS,
            newEligibleMembers
        });
    }, []);
    const updateSelectedSamsUser = useCallback((newSelectedSamsUser) => {
        dispatch({
            type: ManageCardholderModalContextTypes.SET_SELECTED_SAMS_USER,
            newSelectedSamsUser
        });
    }, []);
    const updateIsAuthorizedUserSubmitted = useCallback((newIsAuthorizedUserSubmitted) => {
        dispatch({
            type: ManageCardholderModalContextTypes.SET_IS_USER_SUBMITTED,
            newIsAuthorizedUserSubmitted
        });
    }, []);
    return (_jsx(ManageCardholderModalContext.Provider, { value: useMemo(() => ({
            ...state,
            updateDateOfBirth,
            updateEligibleMembers,
            updateSelectedSamsUser,
            updateIsAuthorizedUserSubmitted
        }), [
            state,
            updateDateOfBirth,
            updateEligibleMembers,
            updateSelectedSamsUser,
            updateIsAuthorizedUserSubmitted
        ]), children: children }));
};
export default ManageCardholderModalContextProvider;
